import { combineReducers } from 'redux';
import detectMarketReducer from './detectMarket';
import selectedMarketReducer from './selectedMarketReducer';

export default combineReducers({
  detectMarket: detectMarketReducer,
  selectedMarket: selectedMarketReducer,
});
